module.exports = "/assets/data/ab9783af6f48b86499e15cffc573aee4-NE46.data.json";